
namespace TabAurous.Inventory{

    export class BranchInPanelOptions {
        items: BranchInRow[];
    }

    export class BranchInPanel extends Serenity.TemplatedPanel<BranchInPanelOptions> {
        constructor(container: JQuery, opt: BranchInPanelOptions) {
            super(container, opt);

            //Grouping
            var data = this.options.items;
            var code = [""];
            var grossamount = [0];
            code.pop();
            grossamount.pop();
            for (var i = 0; i < data.length; i++) {
                var checkexists = false;
                for (var j = 0; j < code.length; j++) {
                    if (data[i].CompanyName.match(code[j])) {
                        checkexists = true;
                        grossamount[j] += data[i].GrossAmount;
                    }
                }
                if (!checkexists) {
                    code.push(data[i].CompanyName);
                    grossamount.push(data[i].GrossAmount);
                }
            }
            var options = {
                chart: {
                    height: 250,
                    width: 430,
                    type: 'line',
                    fontFamily: '"PT Sans", sans-serif',
                    zoom: {
                        enabled: false
                    }
                },
                series: [
                    {
                        name: 'sales',
                        data: grossamount
                    }
                ],

                stroke: {
                    curve: 'straight'
                },
                xaxis: {
                    categories: code
                }
            }
            //var x = document.getElementById('TabAurous_Reports_ChartPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }

    @Serenity.Decorators.registerClass()
    export class ApprovalGrid extends Serenity.EntityGrid<BranchInRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchIn'; }
        protected getDialogType() { return BranchInDialog; }
        protected getIdProperty() { return BranchInRow.idProperty; }
        protected getInsertPermission() { return BranchInRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchInRow.localTextPrefix; }
        protected getService() { return BranchInService.baseUrl; }

        private chartContainer: JQuery;
        private chartPanel: BranchInPanel;
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp= [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },
                
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: "VendorLKUP",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Party',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).VendorIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
          

            return filters;
        }
        onViewProcessData(response: Serenity.ListResponse<BranchInRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new BranchInPanel(this.chartContainer, { items: response.Entities });

            var options = {
                chart: {
                    type: 'bar'
                },
                series: [
                    {
                        name: 'sales',
                        data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
                    }
                ],
                xaxis: {
                    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
                }
            }

            var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

            chart.render();


            return response;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({

                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    
                    Common.ReportHelper.execute({
                        reportKey: 'Reports.ApprovalRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date:this.view.params.Criteria
                        }
                    });
                }
            }
            );
            return buttons;
        }
    }
}